const productForm = document.querySelector('.product-form');
const printingHeading = document.querySelector('[data-printing-add-on-heading]');
const printingAddOn = document.querySelector('[data-component-id="product-add-on-printing"]');
const drawerTrigger = printingAddOn?.querySelector('[data-trigger-print-empty]');
const printingDrawer = printingAddOn?.querySelector('#product-add-on-printing');
const addToOrderButton = printingDrawer?.querySelector('#add-printing-to-order-button');
const spinner = addToOrderButton?.querySelector('.add-on-spinner');

if (!productForm || !printingAddOn && !addToOrderButton && !printingDrawer && !drawerTrigger) return;

const drawerTriggerEmpty = drawerTrigger?.cloneNode(true);
const triggerTemplateWhenPrintChosen = document.querySelector('[data-trigger-chosen-print-template]');

const closeDrawerButton = printingDrawer?.querySelector('[data-drawer-close]');
const chosenAddOnProduct = printingDrawer?.querySelector('[data-printing-addon-inputs]');
const chosenPrintingService = printingDrawer?.querySelector('[data-printing-product-inputs]');
const chosenOwnName = printingDrawer?.querySelector('[name="own_text"]');
const chosenOwnNumber = printingDrawer?.querySelector('[name="own_number"]');
const printingPriceEl = printingDrawer?.querySelector('[data-main-printing-price]');
const printingAddOnCheckboxes = document.querySelectorAll('[data-printing-add-on]');
const predefinedPrintTab = printingDrawer?.querySelector('[data-button-type="predefined"]');
const customPrintTab = printingDrawer?.querySelector('[data-button-type="custom"]');
let selectPlaceholder = printingAddOn?.querySelector('[data-select-placeholder-content]');
const selectDefaultValue = selectPlaceholder?.innerText;
const selectOptions = printingAddOn?.querySelector('[data-select-options]');
const addToTheCartButton = document.querySelector('button[id*="Add-to-cart-template--"][type="submit"][name="add"]');

function handleAddToOrder() {
  if (!isPrintInputValid()) return;

  const [predefinedTabOpen, customTabOpen] = [predefinedPrintTab?.dataset?.tabOpen, customPrintTab?.dataset?.tabOpen];
  let printName;


  if (predefinedTabOpen) {
    const selectValue = selectPlaceholder?.innerText;
    drawerTrigger.innerHTML = triggerTemplateWhenPrintChosen?.innerHTML;
    printName = (selectValue) ? selectValue : selectDefaultValue;
  } else if (customTabOpen) {
    const ownName = chosenOwnName?.value?.trim();
    const ownNumber = chosenOwnNumber?.value?.trim();
    if (!ownNumber || !ownName) return;
    drawerTrigger.innerHTML = triggerTemplateWhenPrintChosen?.innerHTML;
    printName = ownNumber + ' ' + ownName;
  } else {
    return;
  }

  // Trigger printing service
  const triggerPrintName = drawerTrigger?.querySelector('[data-label-print-name]');
  if (!triggerPrintName || !printName) return;
  triggerPrintName.innerText = printName;
  if (chosenPrintingService) drawerTrigger?.append(chosenPrintingService);

  // Trigger add on product
  const triggerAddOn = drawerTrigger?.querySelector('[data-label-selected-add-on]');
  const triggerAddOnName = triggerAddOn?.querySelector('[data-label-print-add-on-name]');
  const triggerAddOnPriceEl = triggerAddOn?.querySelector('[data-label-print_price');
  let triggerAddOnPrices = [];
  let checkedAddOn = false;

  if (triggerAddOnName || triggerAddOnPriceEl) {
    printingAddOnCheckboxes?.forEach(addOn => {
      if (addOn?.children[0]?.checked) {
        triggerAddOnName.innerText = addOn?.children[2]?.innerText;
        triggerAddOnPriceEl.innerText = addOn?.nextElementSibling?.innerText;
        triggerAddOnPrices.push(addOn?.nextElementSibling?.innerText);
        checkedAddOn = true;
      }

      if (checkedAddOn) {
        triggerAddOn?.classList.remove('hidden');
      }
    })
  }

  let price = triggerTemplateWhenPrintChosen?.dataset?.mainPrintingPrice;
  let format = triggerTemplateWhenPrintChosen?.dataset?.mainPrintingCurrency;

  // If add on is chosen - sum printing service and add on product & format currency
  if (checkedAddOn && triggerAddOnPrices.length) {
    price = sumFormattedPrices(price, ...triggerAddOnPrices);
    price = format.replace('{{amount_with_comma_separator}}', price)
    if (chosenAddOnProduct) drawerTrigger?.append(chosenAddOnProduct);
  }

  // Update price
  if (price && printingHeading) {
    printingHeading?.querySelector('[data-add-on-total]')?.remove();
    printingHeading?.insertAdjacentHTML('beforeend', `<span data-add-on-total>+ ${price}</span>`);
  }

  // Enable chosen products/services to add to cart
  const printingInputs = drawerTrigger?.querySelectorAll('[data-printing-input]');
  const printingNameInput = drawerTrigger?.querySelector('[name="printing_product_text"]');
  if (!printingNameInput) return;

  printingInputs?.forEach(input => {
    input.removeAttribute('disabled');
  });
  printingNameInput.value = printName;

  if (chosenPrintingService) productForm?.appendChild(chosenPrintingService);

  const trashButton = drawerTrigger?.querySelector('[data-remove-printing]');
  trashButton?.addEventListener('click', handleRemoveFromOrder);

  addToTheCartButton?.click();
  trashButton?.click();

  spinner?.classList.remove('hidden');

  document.addEventListener('cart:updated', removeSpinner);
}

function removeSpinner() {
  spinner?.classList.add('hidden');
  document.removeEventListener('cart:updated', removeSpinner);
}

addToOrderButton?.addEventListener('click', handleAddToOrder);

function handleRemoveFromOrder() {
  event?.stopPropagation();

  const chosenPrintingProduct = productForm?.querySelector('[data-printing-product-inputs]');
  chosenPrintingProduct?.remove();

  drawerTrigger.innerHTML = drawerTriggerEmpty.innerHTML;
  printingHeading?.querySelector('[data-add-on-total]')?.remove();
}

function isPrintInputValid() {
  if (!addToOrderButton) return;

  const [predefinedTabOpen, customTabOpen] = [predefinedPrintTab?.dataset?.tabOpen, customPrintTab?.dataset?.tabOpen];

  if (predefinedTabOpen) {
    return true;
  }

  if (customTabOpen) {
    const ownName = chosenOwnName?.value?.trim();
    const ownNumber = chosenOwnNumber?.value?.trim();

    if (!ownName) {
      printingDrawer?.querySelector('[data-error-text="shirtname-required"]')?.classList.remove('hidden');
    } else {
      printingDrawer?.querySelector('[data-error-text="shirtname"]')?.classList.add('hidden');
    }

    if (!ownNumber) {
      printingDrawer?.querySelector('[data-error-text="shirtno-required"]')?.classList.remove('hidden');
    } else {
      printingDrawer?.querySelector('[data-error-text="shirtno"]')?.classList.add('hidden');
    }

    if (!ownNumber || !ownName) return false;

    printingDrawer?.querySelector('[data-error-text="shirtname"]')?.classList.add('hidden');
    printingDrawer?.querySelector('[data-error-text="shirtno"]')?.classList.add('hidden');

    return true;
  }
}

function validateInputs(e) {
  const trigger = e.target;
  const inputValue = trigger.value.trim();
  const isTriggerInput = trigger.tagName === 'INPUT';
  let checkmarkSvg = trigger?.closest('[data-auth-input]')?.querySelector('[data-auth-checkmark] svg');

  if (trigger.type !== 'text' && trigger.type !== 'number' || !checkmarkSvg) return;

  if (isTriggerInput && inputValue) {
    checkmarkSvg.classList.remove('hidden');
  } else {
    checkmarkSvg.classList.add('hidden');
  }
}

function sumFormattedPrices(...values) {
  let sum = 0;

  values.forEach(value => {
    value = value.replace(/\./g, '').replace(/,/g, '.');
    const num = parseFloat(value);
    sum += num;
  });

  sum = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(sum);

  return sum;
}